import { CustomTooltip } from '@/shared/ui/components';
import { t } from 'ttag';
import { biodirectProgressRenderer } from './handler';
import { useBiodirectProgress } from './useBiodirectProgress';
import InfoIcon from './assets/images/info-icon.svg';
import type { BiodirectProgressProps } from './biodirectProgress.types';
import './biodirectProgress.scss';

/**
 * Renders the Biodirect tag row of a study card. Nothing is rendered when useBiodirectProgress reports the study is not Biodirect, otherwise a tooltipped Biodirect button with an info icon triggers the details callback and is followed by the shipment progress chip from biodirectProgressRenderer.
 *
 * @param study - The study whose Biodirect state is displayed.
 * @param onViewBiodirectInfoClick - Callback invoked when the Biodirect tag is clicked.
 * @returns The Biodirect tag row, or null for non-Biodirect studies.
 */
const BiodirectProgress = ({ study, onViewBiodirectInfoClick }: BiodirectProgressProps) => {
  const { isBiodirectStudy } = useBiodirectProgress(study);

  if (!isBiodirectStudy) {
    return null;
  }

  return (
    <div className="biodirect-tag-list">
      <CustomTooltip title={t`View details`} placement="bottom">
        <button className="biodirect-tag" onClick={onViewBiodirectInfoClick}>
          <span className="biodirect-tag__text">{t`Biodirect`}</span>
          <img className="biodirect-tag__icon" src={InfoIcon} alt="Info icon" />
        </button>
      </CustomTooltip>
      {biodirectProgressRenderer(study)}
    </div>
  );
};

export default BiodirectProgress;
